import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class SeoService {

  private metaDataConfig;
  private localPath;
  _SeoMetaDataSubject: BehaviorSubject<any>;
  constructor(
    private config: ConfigService,
    private http: HttpClient,
    private title: Title, 
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.localPath = './assets/site_content/seo.json';
    this.metaDataConfig = this.config.getConfig().FEATURE_APP_META_TITLE_DESCRIPTION_INFO_FILE ? this.config.getConfig().FEATURE_APP_META_TITLE_DESCRIPTION_INFO_FILE : this.localPath;
    if(this.config.getConfig().FEATURE_APP_META_GOOGLE_SITE_VERIFICATION) {
      this.addGSCMetaTag(this.config.getConfig().FEATURE_APP_META_GOOGLE_SITE_VERIFICATION);
    }
    this._SeoMetaDataSubject = new BehaviorSubject(undefined);
   }

  storeSeoMetaData(){
    this.http.get(this.metaDataConfig).toPromise().then((res: any) => {
      if(res){
        this._SeoMetaDataSubject.next(res);
      }
    }).catch(error => {
      console.error('--Something went wrong to fetch SEO meta data--', error);
      this._SeoMetaDataSubject.error(error);
    });
    return this._SeoMetaDataSubject;
  } 

  updateMeta(route: string){
     this._SeoMetaDataSubject.subscribe((data) => {
      if(data){
        if(Object.prototype.hasOwnProperty.call(data, route)){
          const {title, description} = data[route];
          this.updateTitle(title);
          this.updateDescription(description)
        }
      }
    });
  }

  updateTitle(title: string) {
    if (title) {
      this.title.setTitle(title);
    }
  }

  updateDescription(description: string) {
    if (description) {
      this.meta.updateTag({ name: 'description', content: description });
    }
  }

  addGSCMetaTag(metaContent){
    this.meta.addTag({name: 'google-site-verification', content: metaContent});
    const metaTag = this.document.querySelector('meta[name="google-site-verification"]');
    
    if (metaTag) {
      // Find the title tag
      const titleTag = this.document.querySelector('title');

      if (titleTag && titleTag.parentNode) {
        // Insert the meta tag just after the title tag
        titleTag.parentNode.insertBefore(metaTag, titleTag.nextSibling);
      }
    }
  }
}
